import React from 'react';
import { Input } from 'antd';
import { encryptTextByAES , decryptTextByAES} from "utils/encryption";

interface PropsType {
    value?: any;
    onChange?: any;
}

const SPDeCodeInput: React.FC<PropsType> = (props) => {
    const { value, onChange, ...retProps } = props;

    const sureValue = decryptTextByAES(value || '')

    const onInputChange = (e: any) => {
      onChange(e.target.value ? encryptTextByAES(e.target.value) : '');
    }
    return (
      <Input {...retProps} value={sureValue} onChange={onInputChange}></Input>
    )
}

export default SPDeCodeInput
